import {
  GET_INSTRUCTORS
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_INSTRUCTORS] (state, instructors) {
    // state.all = data
    state.all = instructors.sort(function (a, b) {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/instructors.js